import { useTranslation } from "react-i18next";

import { LegalAgreementsBody } from "@/routes/app/$role/setup/-steps/legal-agreements";

export function TermsPrivacyPanel() {
  const { t } = useTranslation("settings");
  return (
    <div className="flex flex-col gap-6">
      <h3 className="text-xl font-semibold text-garnet mb-2">
        {t("terms.title")}
      </h3>
      <LegalAgreementsBody mode="review" />
    </div>
  );
}
